import { NotificationFailureType } from "../types/notificationTypes";

export const getNotificationFailureTypeName = (type: NotificationFailureType): string => {
  switch (type) {
    case NotificationFailureType.IgnoreFileNotFoundError:
      return "Ignore File Not Found Error";
    default:
      return "Unknown";
  }
};
